/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { withTranslation } from 'react-i18next'
import styles from './Confirmation.module.scss'

const SaveCopy = ({ t, transId, transOwner }) => {
  const baseURL = process.env.REACT_APP_SERVICE_URL

  const createPdf = () => {
    try {
      if (transId && transOwner) {
        var downloadPDFLink = document.createElement('a')
        downloadPDFLink.href = `${baseURL}services/transactionservice/api/renderReceipt?transId=${transId}&transOwner=${transOwner}`
        downloadPDFLink.dispatchEvent(new MouseEvent('click'))
      } else {
        console.log(`Empty transId - ${transId} or transOwner - ${transOwner}`)
      }
    } catch (e) {
      console.log(e)
    }
  }

  return (
    <div className={['print_no_display', styles['margin_left_20']].join(' ')}>
      <button
        onClick={createPdf}
        className={['btn-lg btn-default print_no_display', styles['print_save_margin']].join(' ')}
        value={t('receive_confirmation.save_a_copy')}
        name={t('receive_confirmation.save_a_copy')}
      >
        <i className={['fa fa-floppy-o', styles['save_icon']].join(' ')} aria-hidden="true"></i>&nbsp;&nbsp;
        {t('receive_confirmation.save_a_copy')}
      </button>
    </div>
  )
}

export default withTranslation('common')(SaveCopy)
